export enum RequirementTypes {
  'Nueva Licencia' = 1,
  'Ampliación Licencia',
  'Renovación Licencia',
}
